module.exports = __webpack_public_path__ + "img/Calendar - Blue - Selected.b154c920.png";